export const posts = [
  {
    "slug": "new-year-hours-2024-2024-01-01",
    "title": "Set New Year hours before the week starts, January 1, 2024",
    "seoTitle": "New Year hours (law office, January 1, 2024)",
    "description": "New Year hours for a law office on January 1, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-01-01",
    "cta": "This week, look at New Year hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write New Year hours on the profile and the contact page for 2024. Check them on a phone, because that is where people look the night before.",
          "This January 1, 2024 note is for a law office. The check is New Year hours: New Year hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at New Year hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at New Year hours. In January 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "New Year hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix New Year hours before you add anything",
        "paragraphs": [
          "A mismatch on New Year hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare New Year hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Separate Christmas Eve, Christmas Day, and the days after, December 25, 2023",
        "href": "/blog/christmas-hours-2023-2023-12-25"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "holiday-rush-reviews-2024-01-08",
    "title": "Answer the reviews that came in over the holidays, January 8, 2024",
    "seoTitle": "Holiday review replies (retail shop, January 8, 2024)",
    "description": "Holiday review replies for a retail shop on January 8, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-01-08",
    "cta": "This week, look at reviews from the last few weeks. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A December visit that never got a reply is still the first thing a January customer reads.",
          "This January 8, 2024 note is for a retail shop. The check is holiday review replies: reviews from the last few weeks, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at reviews from the last few weeks",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at reviews from the last few weeks. In January 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Reviews from the last few weeks on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix reviews from the last few weeks before you add anything",
        "paragraphs": [
          "A mismatch on holiday review replies is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare reviews from the last few weeks. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set New Year hours before the week starts, January 1, 2024",
        "href": "/blog/new-year-hours-2024-2024-01-01"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "footer-year-2024-01-15",
    "title": "Update the year in the footer, January 15, 2024",
    "seoTitle": "Website footer year (contractor, January 15, 2024)",
    "description": "Website footer year for a contractor on January 15, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-01-15",
    "cta": "This week, look at the year printed on the site. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A footer that still says a year you have left makes the rest of the page look unattended. Change the year, then stop.",
          "This January 15, 2024 note is for a contractor. The check is website footer year: the year printed on the site, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the year printed on the site",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the year printed on the site. In January 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The year printed on the site on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the year printed on the site before you add anything",
        "paragraphs": [
          "A mismatch on website footer year is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the year printed on the site. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Open the holiday booking calendar, November 27, 2023",
        "href": "/blog/holiday-calendar-2023-11-27"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "january-hours-2024-2024-01-22",
    "title": "Read the January 2024 hours on the door and the listing, January 22, 2024",
    "seoTitle": "January 2024 hours (salon, January 22, 2024)",
    "description": "January 2024 hours for a salon on January 22, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-01-22",
    "cta": "This week, look at the hours for January 2024. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In January 2024, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This January 22, 2024 note is for a salon. The check is January 2024 hours: the hours for January 2024, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for January 2024",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for January 2024. In January 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for January 2024 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for January 2024 before you add anything",
        "paragraphs": [
          "A mismatch on January 2024 hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the hours for January 2024. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Answer the reviews that came in over the holidays, January 8, 2024",
        "href": "/blog/holiday-rush-reviews-2024-01-08"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "january-photo-2024-2024-01-29",
    "title": "Add one January 2024 photo of the real place, January 29, 2024",
    "seoTitle": "January 2024 business photo (clinic, January 29, 2024)",
    "description": "January 2024 business photo for a clinic on January 29, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-01-29",
    "cta": "This week, look at a photo from January 2024. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this January of the door, the work, or the counter. A photo from another season makes 2024 look unattended.",
          "This January 29, 2024 note is for a clinic. The check is January 2024 business photo: a photo from January 2024, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from January 2024",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from January 2024. In January 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from January 2024 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from January 2024 before you add anything",
        "paragraphs": [
          "A mismatch on January 2024 business photo is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a photo from January 2024. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the January 2024 hours on the door and the listing, January 22, 2024",
        "href": "/blog/january-hours-2024-2024-01-22"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "gift-cards-expiring-2024-02-05",
    "title": "Say if gift cards or credits expire, February 5, 2024",
    "seoTitle": "Gift card expiration (restaurant, February 5, 2024)",
    "description": "Gift card expiration for a restaurant on February 5, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-02-05",
    "cta": "This week, look at whether a credit expires. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If a card expires, say so where people redeem it. If it does not expire, say that too.",
          "This February 5, 2024 note is for a restaurant. The check is gift card expiration: whether a credit expires, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at whether a credit expires",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at whether a credit expires. In February 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Whether a credit expires on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix whether a credit expires before you add anything",
        "paragraphs": [
          "A mismatch on gift card expiration is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare whether a credit expires. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the year in the footer, January 15, 2024",
        "href": "/blog/footer-year-2024-01-15"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "valentine-hours-2024-2024-02-12",
    "title": "Put Valentine's week hours and the offer in one place, February 12, 2024",
    "seoTitle": "Valentine's week hours (law office, February 12, 2024)",
    "description": "Valentine's week hours for a law office on February 12, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-02-12",
    "cta": "This week, look at Valentine's week. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If 2024 includes a Valentine offer or a fuller book, say the hours and the last day of the offer. Leave the business name alone.",
          "This February 12, 2024 note is for a law office. The check is Valentine's week hours: Valentine's week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Valentine's week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Valentine's week. In February 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Valentine's week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Valentine's week before you add anything",
        "paragraphs": [
          "A mismatch on Valentine's week hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Valentine's week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one January 2024 photo of the real place, January 29, 2024",
        "href": "/blog/january-photo-2024-2024-01-29"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "popup-over-february-offer-2024-02-19",
    "title": "Do not let a popup cover the phone, February 19, 2024",
    "seoTitle": "Popup over a phone number (retail shop, February 19, 2024)",
    "description": "Popup over a phone number for a retail shop on February 19, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-02-19",
    "cta": "This week, look at a popup covering the number. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A holiday graphic that sits on top of the number costs calls. The offer can live under the number, not on it.",
          "This February 19, 2024 note is for a retail shop. The check is popup over a phone number: a popup covering the number, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a popup covering the number",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a popup covering the number. In February 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A popup covering the number on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a popup covering the number before you add anything",
        "paragraphs": [
          "A mismatch on popup over a phone number is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a popup covering the number. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say if gift cards or credits expire, February 5, 2024",
        "href": "/blog/gift-cards-expiring-2024-02-05"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "february-staffing-2024-02-26",
    "title": "Match February hours to who is working, February 26, 2024",
    "seoTitle": "February staffing hours (contractor, February 26, 2024)",
    "description": "February staffing hours for a contractor on February 26, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-02-26",
    "cta": "This week, look at hours that match who is in. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A short month with people out is a shorter public schedule. Publish the hours you can keep.",
          "This February 26, 2024 note is for a contractor. The check is February staffing hours: hours that match who is in, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours that match who is in",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours that match who is in. In February 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours that match who is in on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours that match who is in before you add anything",
        "paragraphs": [
          "A mismatch on February staffing hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare hours that match who is in. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put Valentine's week hours and the offer in one place, February 12, 2024",
        "href": "/blog/valentine-hours-2024-2024-02-12"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "entrance-after-winter-2024-03-04",
    "title": "Move the pin if winter construction changed the door, March 4, 2024",
    "seoTitle": "Google Maps pin (salon, March 4, 2024)",
    "description": "Google Maps pin for a salon on March 4, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-03-04",
    "cta": "This week, look at the door the pin should mark. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the entrance moved, drop the pin on the door people use now. The old walkway is how cars stop at the wrong building.",
          "This March 4, 2024 note is for a salon. The check is Google Maps pin: the door the pin should mark, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the door the pin should mark",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the door the pin should mark. In March 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The door the pin should mark on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the door the pin should mark before you add anything",
        "paragraphs": [
          "A mismatch on Google Maps pin is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the door the pin should mark. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Match February hours to who is working, February 26, 2024",
        "href": "/blog/february-staffing-2024-02-26"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "clear-winter-banners-2024-03-11",
    "title": "Clear winter banners off the homepage, March 11, 2024",
    "seoTitle": "Old homepage banner (clinic, March 11, 2024)",
    "description": "Old homepage banner for a clinic on March 11, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-03-11",
    "cta": "This week, look at a banner from a season that ended. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A storm-closure or holiday strip that is still at the top of the page is the first thing a March visitor believes.",
          "This March 11, 2024 note is for a clinic. The check is old homepage banner: a banner from a season that ended, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a banner from a season that ended",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a banner from a season that ended. In March 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A banner from a season that ended on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a banner from a season that ended before you add anything",
        "paragraphs": [
          "A mismatch on old homepage banner is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a banner from a season that ended. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Do not let a popup cover the phone, February 19, 2024",
        "href": "/blog/popup-over-february-offer-2024-02-19"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "one-spring-offer-2024-03-18",
    "title": "Publish one spring offer, with an end date, March 18, 2024",
    "seoTitle": "Spring promotion (restaurant, March 18, 2024)",
    "description": "Spring promotion for a restaurant on March 18, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-03-18",
    "cta": "This week, look at one dated spring offer. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Name the offer and the last day. An open-ended sale becomes the thing you forget to take down in July.",
          "This March 18, 2024 note is for a restaurant. The check is spring promotion: one dated spring offer, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at one dated spring offer",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at one dated spring offer. In March 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "One dated spring offer on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix one dated spring offer before you add anything",
        "paragraphs": [
          "A mismatch on spring promotion is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare one dated spring offer. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Clear winter banners off the homepage, March 11, 2024",
        "href": "/blog/clear-winter-banners-2024-03-11"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "easter-hours-2024-2024-03-25",
    "title": "Write Easter week hours as special hours, March 25, 2024",
    "seoTitle": "Easter week hours (law office, March 25, 2024)",
    "description": "Easter week hours for a law office on March 25, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-03-25",
    "cta": "This week, look at Easter week hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Easter week in 2024 is not a normal week. Mark the day you close, and leave the rest of the weekly schedule as the days you are open.",
          "This March 25, 2024 note is for a law office. The check is Easter week hours: Easter week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Easter week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Easter week hours. In March 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Easter week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Easter week hours before you add anything",
        "paragraphs": [
          "A mismatch on Easter week hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Easter week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Move the pin if winter construction changed the door, March 4, 2024",
        "href": "/blog/entrance-after-winter-2024-03-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "april-review-photos-2024-04-01",
    "title": "Add a photo to the listing with a finished job, April 1, 2024",
    "seoTitle": "New listing photo (retail shop, April 1, 2024)",
    "description": "New listing photo for a retail shop on April 1, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-04-01",
    "cta": "This week, look at one new photo on the listing. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A single current photo does more than a paragraph. Use a job you have permission to show.",
          "This April 1, 2024 note is for a retail shop. The check is new listing photo: one new photo on the listing, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at one new photo on the listing",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at one new photo on the listing. In April 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "One new photo on the listing on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix one new photo on the listing before you add anything",
        "paragraphs": [
          "A mismatch on new listing photo is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare one new photo on the listing. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Easter week hours as special hours, March 25, 2024",
        "href": "/blog/easter-hours-2024-2024-03-25"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "spring-homepage-lead-2024-04-08",
    "title": "Put this month's job in the first sentence, April 8, 2024",
    "seoTitle": "Homepage first sentence (contractor, April 8, 2024)",
    "description": "Homepage first sentence for a contractor on April 8, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-04-08",
    "cta": "This week, look at the first sentence on the phone. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In one breath: what you do, where, and how to call. April visitors will not scroll for it.",
          "This April 8, 2024 note is for a contractor. The check is homepage first sentence: the first sentence on the phone, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the first sentence on the phone",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the first sentence on the phone. In April 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The first sentence on the phone on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the first sentence on the phone before you add anything",
        "paragraphs": [
          "A mismatch on homepage first sentence is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the first sentence on the phone. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish one spring offer, with an end date, March 18, 2024",
        "href": "/blog/one-spring-offer-2024-03-18"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "allergy-season-indoor-2024-04-15",
    "title": "Say what is different about an indoor visit now, April 15, 2024",
    "seoTitle": "Indoor visit details (salon, April 15, 2024)",
    "description": "Indoor visit details for a salon on April 15, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-04-15",
    "cta": "This week, look at what an indoor visit is like. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the wait, the room, or the hours changed with the season, say the current version. Do not describe last fall.",
          "This April 15, 2024 note is for a salon. The check is indoor visit details: what an indoor visit is like, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what an indoor visit is like",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what an indoor visit is like. In April 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What an indoor visit is like on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what an indoor visit is like before you add anything",
        "paragraphs": [
          "A mismatch on indoor visit details is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare what an indoor visit is like. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put this month's job in the first sentence, April 8, 2024",
        "href": "/blog/spring-homepage-lead-2024-04-08"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "april-deposit-2024-04-22",
    "title": "State the deposit or trip charge in one sentence, April 22, 2024",
    "seoTitle": "Deposit or trip charge (clinic, April 22, 2024)",
    "description": "Deposit or trip charge for a clinic on April 22, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-04-22",
    "cta": "This week, look at the deposit or trip charge. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you charge to come out, say so before they book. A surprise fee is a review you have to answer later.",
          "This April 22, 2024 note is for a clinic. The check is deposit or trip charge: the deposit or trip charge, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the deposit or trip charge",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the deposit or trip charge. In April 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The deposit or trip charge on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the deposit or trip charge before you add anything",
        "paragraphs": [
          "A mismatch on deposit or trip charge is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the deposit or trip charge. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say what is different about an indoor visit now, April 15, 2024",
        "href": "/blog/allergy-season-indoor-2024-04-15"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "clear-the-spring-popup-2024-04-29",
    "title": "Remove a popup that blocks the April offer, April 29, 2024",
    "seoTitle": "Popup blocking the page (restaurant, April 29, 2024)",
    "description": "Popup blocking the page for a restaurant on April 29, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-04-29",
    "cta": "This week, look at anything covering the number. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The offer and the number both have to be tappable. If a graphic covers either one, delete the graphic.",
          "This April 29, 2024 note is for a restaurant. The check is popup blocking the page: anything covering the number, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at anything covering the number",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at anything covering the number. In April 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Anything covering the number on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix anything covering the number before you add anything",
        "paragraphs": [
          "A mismatch on popup blocking the page is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare anything covering the number. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "State the deposit or trip charge in one sentence, April 22, 2024",
        "href": "/blog/april-deposit-2024-04-22"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "mother-hours-2024-2024-05-06",
    "title": "Say how Mother's Day bookings work this year, May 6, 2024",
    "seoTitle": "Mother's Day bookings (law office, May 6, 2024)",
    "description": "Mother's Day bookings for a law office on May 6, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-05-06",
    "cta": "This week, look at Mother's Day bookings. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The week of Mother's Day in 2024 fills early for a lot of shops. Say whether you are taking reservations, walk-ins, or neither, and the hour you stop.",
          "This May 6, 2024 note is for a law office. The check is Mother's Day bookings: Mother's Day bookings, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Mother's Day bookings",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Mother's Day bookings. In May 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Mother's Day bookings on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Mother's Day bookings before you add anything",
        "paragraphs": [
          "A mismatch on Mother's Day bookings is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Mother's Day bookings. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add a photo to the listing with a finished job, April 1, 2024",
        "href": "/blog/april-review-photos-2024-04-01"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "ai-overview-needs-your-page-2024-2024-05-13",
    "title": "An AI Overview does not replace your page, May 13, 2024",
    "seoTitle": "AI Overview and your page (retail shop, May 13, 2024)",
    "description": "AI Overview and your page for a retail shop on May 13, 2024. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2024-05-13",
    "cta": "This week, look at the page under an AI Overview. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In May 2024 search started showing AI Overviews above the links more often. The overview is not a booking. The page under it still has to name the job, the area, and the phone.",
          "This May 13, 2024 note is for a retail shop. The check is AI Overview and your page: the page under an AI Overview, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the page under an AI Overview",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the page under an AI Overview. In May 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The page under an AI Overview on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the page under an AI Overview before you add anything",
        "paragraphs": [
          "A mismatch on AI Overview and your page is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the page under an AI Overview. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the current page up while you edit, December 11, 2023",
        "href": "/blog/keep-the-old-page-until-2023-12-11"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "may-sale-under-the-number-2024-05-20",
    "title": "Put a May offer under the phone number, May 20, 2024",
    "seoTitle": "May promotion placement (contractor, May 20, 2024)",
    "description": "May promotion placement for a contractor on May 20, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-05-20",
    "cta": "This week, look at where the offer sits. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The number stays first. The offer can follow it. The other way around loses the call.",
          "This May 20, 2024 note is for a contractor. The check is May promotion placement: where the offer sits, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at where the offer sits",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at where the offer sits. In May 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Where the offer sits on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix where the offer sits before you add anything",
        "paragraphs": [
          "A mismatch on May promotion placement is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare where the offer sits. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Remove a popup that blocks the April offer, April 29, 2024",
        "href": "/blog/clear-the-spring-popup-2024-04-29"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "memorial-hours-2024-2024-05-27",
    "title": "Mark Memorial Day on the listing, May 27, 2024",
    "seoTitle": "Memorial Day hours (salon, May 27, 2024)",
    "description": "Memorial Day hours for a salon on May 27, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-05-27",
    "cta": "This week, look at Memorial Day hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Memorial Day 2024 is a Monday. If you are closed, the weekly Monday hours will still look open unless you add a special hour.",
          "This May 27, 2024 note is for a salon. The check is Memorial Day hours: Memorial Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Memorial Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Memorial Day hours. In May 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Memorial Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Memorial Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Memorial Day hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Memorial Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how Mother's Day bookings work this year, May 6, 2024",
        "href": "/blog/mother-hours-2024-2024-05-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "early-start-2024-06-03",
    "title": "Say if crews or the shop start earlier, June 3, 2024",
    "seoTitle": "Early opening hours (clinic, June 3, 2024)",
    "description": "Early opening hours for a clinic on June 3, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-06-03",
    "cta": "This week, look at the time you actually start. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "An earlier start that is only in your head still shows the old opening time on the map.",
          "This June 3, 2024 note is for a clinic. The check is early opening hours: the time you actually start, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the time you actually start",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the time you actually start. In June 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The time you actually start on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the time you actually start before you add anything",
        "paragraphs": [
          "A mismatch on early opening hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the time you actually start. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Memorial Day on the listing, May 27, 2024",
        "href": "/blog/memorial-hours-2024-2024-05-27"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "father-hours-2024-2024-06-10",
    "title": "Set Father's Day week hours and capacity, June 10, 2024",
    "seoTitle": "Father's Day hours (restaurant, June 10, 2024)",
    "description": "Father's Day hours for a restaurant on June 10, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-06-10",
    "cta": "This week, look at Father's Day week. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If Father's Day 2024 changes the book or the menu, put the hours and the limit on the listing. Take it down the next week.",
          "This June 10, 2024 note is for a restaurant. The check is Father's Day hours: Father's Day week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Father's Day week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Father's Day week. In June 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Father's Day week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Father's Day week before you add anything",
        "paragraphs": [
          "A mismatch on Father's Day hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Father's Day week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say if crews or the shop start earlier, June 3, 2024",
        "href": "/blog/early-start-2024-06-03"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "overview-omits-the-number-2024-06-17",
    "title": "Put the phone number where a summary might skip it, June 17, 2024",
    "seoTitle": "Phone number and an AI Overview (law office, June 17, 2024)",
    "description": "Phone number and an AI Overview for a law office on June 17, 2024. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2024-06-17",
    "cta": "This week, look at the phone number on the page. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A summary can describe the business and forget the number. The first screen still has to dial.",
          "This June 17, 2024 note is for a law office. The check is phone number and an AI Overview: the phone number on the page, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the phone number on the page",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the phone number on the page. In June 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The phone number on the page on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the phone number on the page before you add anything",
        "paragraphs": [
          "A mismatch on phone number and an AI Overview is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the phone number on the page. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "An AI Overview does not replace your page, May 13, 2024",
        "href": "/blog/ai-overview-needs-your-page-2024-2024-05-13"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "summer-daylight-photo-2024-06-24",
    "title": "Use a photo taken in full summer light, June 24, 2024",
    "seoTitle": "Summer photo of the shop (retail shop, June 24, 2024)",
    "description": "Summer photo of the shop for a retail shop on June 24, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-06-24",
    "cta": "This week, look at a photo from this month. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Shade, signage, and the lot look different now. One new photo keeps the listing from looking abandoned.",
          "This June 24, 2024 note is for a retail shop. The check is summer photo of the shop: a photo from this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from this month. In June 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from this month before you add anything",
        "paragraphs": [
          "A mismatch on summer photo of the shop is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a photo from this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Father's Day week hours and capacity, June 10, 2024",
        "href": "/blog/father-hours-2024-2024-06-10"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july4-hours-2024-2024-07-01",
    "title": "Write July 4 hours before the weekend, July 1, 2024",
    "seoTitle": "July 4 hours (contractor, July 1, 2024)",
    "description": "July 4 hours for a contractor on July 1, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-07-01",
    "cta": "This week, look at July 4 hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Set July 4, 2024 hours on the profile. A short summary in search can repeat an old hour, so the profile has to be the one that is right.",
          "This July 1, 2024 note is for a contractor. The check is July 4 hours: July 4 hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at July 4 hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at July 4 hours. In July 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "July 4 hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix July 4 hours before you add anything",
        "paragraphs": [
          "A mismatch on July 4 hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare July 4 hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Use a photo taken in full summer light, June 24, 2024",
        "href": "/blog/summer-daylight-photo-2024-06-24"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july-menu-2024-07-08",
    "title": "Update the July menu or service list, July 8, 2024",
    "seoTitle": "July menu (salon, July 8, 2024)",
    "description": "July menu for a salon on July 8, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-07-08",
    "cta": "This week, look at what you are serving or selling now. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Seasonal items change. The list on the site has to match the one the counter is using today.",
          "This July 8, 2024 note is for a salon. The check is July menu: what you are serving or selling now, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what you are serving or selling now",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what you are serving or selling now. In July 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What you are serving or selling now on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what you are serving or selling now before you add anything",
        "paragraphs": [
          "A mismatch on July menu is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare what you are serving or selling now. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish the June menu or service list as text, June 26, 2023",
        "href": "/blog/june-menu-2023-06-26"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "longer-july-waits-2024-07-15",
    "title": "Tell the truth about July wait times, July 15, 2024",
    "seoTitle": "July wait time (clinic, July 15, 2024)",
    "description": "July wait time for a clinic on July 15, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-07-15",
    "cta": "This week, look at the wait this month. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are further out than June, change the sentence. Leaving the old wait up books people you cannot take.",
          "This July 15, 2024 note is for a clinic. The check is July wait time: the wait this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the wait this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the wait this month. In July 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The wait this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the wait this month before you add anything",
        "paragraphs": [
          "A mismatch on July wait time is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the wait this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put a May offer under the phone number, May 20, 2024",
        "href": "/blog/may-sale-under-the-number-2024-05-20"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "overview-old-service-2024-07-22",
    "title": "Remove a service you no longer offer before a summary repeats it, July 22, 2024",
    "seoTitle": "Outdated service in an AI Overview (restaurant, July 22, 2024)",
    "description": "Outdated service in an AI Overview for a restaurant on July 22, 2024. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2024-07-22",
    "cta": "This week, look at a service you stopped. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the page still lists it, a summary can repeat it. Delete the line.",
          "This July 22, 2024 note is for a restaurant. The check is outdated service in an AI Overview: a service you stopped, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a service you stopped",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a service you stopped. In July 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A service you stopped on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a service you stopped before you add anything",
        "paragraphs": [
          "A mismatch on outdated service in an AI Overview is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare a service you stopped. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put the phone number where a summary might skip it, June 17, 2024",
        "href": "/blog/overview-omits-the-number-2024-06-17"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "shop-hours-versus-crew-2024-07-29",
    "title": "Separate shop hours from crew hours, July 29, 2024",
    "seoTitle": "Shop hours versus job hours (law office, July 29, 2024)",
    "description": "Shop hours versus job hours for a law office on July 29, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-07-29",
    "cta": "This week, look at which hours are which. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The office can be open when the crew is on a job, or the reverse. Write the one a customer can use.",
          "This July 29, 2024 note is for a law office. The check is shop hours versus job hours: which hours are which, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at which hours are which",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at which hours are which. In July 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Which hours are which on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix which hours are which before you add anything",
        "paragraphs": [
          "A mismatch on shop hours versus job hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare which hours are which. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write July 4 hours before the weekend, July 1, 2024",
        "href": "/blog/july4-hours-2024-2024-07-01"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "august-categories-2024-08-05",
    "title": "Recheck categories before the fall rush, August 5, 2024",
    "seoTitle": "Listing categories (retail shop, August 5, 2024)",
    "description": "Listing categories for a retail shop on August 5, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-08-05",
    "cta": "This week, look at categories before fall. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The primary category should still be the work you want in September. Side categories that are no longer true should go.",
          "This August 5, 2024 note is for a retail shop. The check is listing categories: categories before fall, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at categories before fall",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at categories before fall. In August 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Categories before fall on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix categories before fall before you add anything",
        "paragraphs": [
          "A mismatch on listing categories is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare categories before fall. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Separate shop hours from crew hours, July 29, 2024",
        "href": "/blog/shop-hours-versus-crew-2024-07-29"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "school-hours-2024-2024-08-12",
    "title": "Publish back-to-school hours the week they start, August 12, 2024",
    "seoTitle": "Back-to-school hours (contractor, August 12, 2024)",
    "description": "Back-to-school hours for a contractor on August 12, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-08-12",
    "cta": "This week, look at back-to-school hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "School schedules in 2024 change the rush hour. Write the hours you will keep once classes start, on the listing and the page.",
          "This August 12, 2024 note is for a contractor. The check is back-to-school hours: back-to-school hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at back-to-school hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at back-to-school hours. In August 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Back-to-school hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix back-to-school hours before you add anything",
        "paragraphs": [
          "A mismatch on back-to-school hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare back-to-school hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Recheck categories before the fall rush, August 5, 2024",
        "href": "/blog/august-categories-2024-08-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "august-hours-2024-2024-08-19",
    "title": "Read the August 2024 hours on the door and the listing, August 19, 2024",
    "seoTitle": "August 2024 hours (salon, August 19, 2024)",
    "description": "August 2024 hours for a salon on August 19, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-08-19",
    "cta": "This week, look at the hours for August 2024. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In August 2024, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This August 19, 2024 note is for a salon. The check is August 2024 hours: the hours for August 2024, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for August 2024",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for August 2024. In August 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for August 2024 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for August 2024 before you add anything",
        "paragraphs": [
          "A mismatch on August 2024 hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the hours for August 2024. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish back-to-school hours the week they start, August 12, 2024",
        "href": "/blog/school-hours-2024-2024-08-12"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "first-sentence-quotable-2024-08-26",
    "title": "Write a first sentence that states the facts, August 26, 2024",
    "seoTitle": "First sentence on a service page (clinic, August 26, 2024)",
    "description": "First sentence on a service page for a clinic on August 26, 2024. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2024-08-26",
    "cta": "This week, look at the first sentence. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Say the service, the area, and how to start. A summary can only repeat what you wrote clearly.",
          "This August 26, 2024 note is for a clinic. The check is first sentence on a service page: the first sentence, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the first sentence",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the first sentence. In August 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The first sentence on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the first sentence before you add anything",
        "paragraphs": [
          "A mismatch on first sentence on a service page is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the first sentence. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Remove a service you no longer offer before a summary repeats it, July 22, 2024",
        "href": "/blog/overview-old-service-2024-07-22"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "labor-hours-2024-2024-09-02",
    "title": "Mark Labor Day closed if the door will be locked, September 2, 2024",
    "seoTitle": "Labor Day hours (restaurant, September 2, 2024)",
    "description": "Labor Day hours for a restaurant on September 2, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-09-02",
    "cta": "This week, look at Labor Day hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Labor Day 2024 is a Monday. Add the special hour. A description that mentions the holiday is not a substitute.",
          "This September 2, 2024 note is for a restaurant. The check is Labor Day hours: Labor Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Labor Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Labor Day hours. In September 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Labor Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Labor Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Labor Day hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Labor Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the August 2024 hours on the door and the listing, August 19, 2024",
        "href": "/blog/august-hours-2024-2024-08-19"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "review-cleanup-2024-09-09",
    "title": "Clear unanswered reviews from the summer, September 9, 2024",
    "seoTitle": "Unanswered reviews (law office, September 9, 2024)",
    "description": "Unanswered reviews for a law office on September 9, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-09-09",
    "cta": "This week, look at reviews still waiting on a reply. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Anything from June that still has no reply is part of the September first impression.",
          "This September 9, 2024 note is for a law office. The check is unanswered reviews: reviews still waiting on a reply, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at reviews still waiting on a reply",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at reviews still waiting on a reply. In September 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Reviews still waiting on a reply on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix reviews still waiting on a reply before you add anything",
        "paragraphs": [
          "A mismatch on unanswered reviews is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare reviews still waiting on a reply. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Labor Day closed if the door will be locked, September 2, 2024",
        "href": "/blog/labor-hours-2024-2024-09-02"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "september-holiday-2024-09-16",
    "title": "Write hours for a September holiday that is not Labor Day, September 16, 2024",
    "seoTitle": "September holiday hours (retail shop, September 16, 2024)",
    "description": "September holiday hours for a retail shop on September 16, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-09-16",
    "cta": "This week, look at a mid-month holiday closure. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close for another September holiday, add that special hour. Labor Day alone does not cover it.",
          "This September 16, 2024 note is for a retail shop. The check is September holiday hours: a mid-month holiday closure, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a mid-month holiday closure",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a mid-month holiday closure. In September 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A mid-month holiday closure on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a mid-month holiday closure before you add anything",
        "paragraphs": [
          "A mismatch on September holiday hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a mid-month holiday closure. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Clear unanswered reviews from the summer, September 9, 2024",
        "href": "/blog/review-cleanup-2024-09-09"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "q3-phone-check-2024-09-23",
    "title": "Call the number on the website and the listing, September 23, 2024",
    "seoTitle": "Matching phone numbers (contractor, September 23, 2024)",
    "description": "Matching phone numbers for a contractor on September 23, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-09-23",
    "cta": "This week, look at both phone numbers. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "They should be the same call. A second number 'for the office' is how September leads die.",
          "This September 23, 2024 note is for a contractor. The check is matching phone numbers: both phone numbers, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at both phone numbers",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at both phone numbers. In September 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Both phone numbers on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix both phone numbers before you add anything",
        "paragraphs": [
          "A mismatch on matching phone numbers is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare both phone numbers. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write hours for a September holiday that is not Labor Day, September 16, 2024",
        "href": "/blog/september-holiday-2024-09-16"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "overview-hours-from-profile-2024-09-30",
    "title": "Fix profile hours if a summary has them wrong, September 30, 2024",
    "seoTitle": "AI Overview hours (salon, September 30, 2024)",
    "description": "AI Overview hours for a salon on September 30, 2024. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2024-09-30",
    "cta": "This week, look at hours inside a summary. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Hours in a summary come from the profile and the page. Correct the profile, then look again later.",
          "This September 30, 2024 note is for a salon. The check is AI Overview hours: hours inside a summary, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours inside a summary",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours inside a summary. In September 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours inside a summary on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours inside a summary before you add anything",
        "paragraphs": [
          "A mismatch on AI Overview hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare hours inside a summary. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write a first sentence that states the facts, August 26, 2024",
        "href": "/blog/first-sentence-quotable-2024-08-26"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "october-cities-2024-10-07",
    "title": "Confirm the cities you will still drive to, October 7, 2024",
    "seoTitle": "October service area (clinic, October 7, 2024)",
    "description": "October service area for a clinic on October 7, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-10-07",
    "cta": "This week, look at cities you will drive to. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Shorter days change how far you go. Update the list to the trips you will take.",
          "This October 7, 2024 note is for a clinic. The check is October service area: cities you will drive to, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at cities you will drive to",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at cities you will drive to. In October 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Cities you will drive to on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix cities you will drive to before you add anything",
        "paragraphs": [
          "A mismatch on October service area is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare cities you will drive to. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Call the number on the website and the listing, September 23, 2024",
        "href": "/blog/q3-phone-check-2024-09-23"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "october-hours-2024-2024-10-14",
    "title": "Read the October 2024 hours on the door and the listing, October 14, 2024",
    "seoTitle": "October 2024 hours (restaurant, October 14, 2024)",
    "description": "October 2024 hours for a restaurant on October 14, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-10-14",
    "cta": "This week, look at the hours for October 2024. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In October 2024, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This October 14, 2024 note is for a restaurant. The check is October 2024 hours: the hours for October 2024, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for October 2024",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for October 2024. In October 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for October 2024 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for October 2024 before you add anything",
        "paragraphs": [
          "A mismatch on October 2024 hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the hours for October 2024. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Confirm the cities you will still drive to, October 7, 2024",
        "href": "/blog/october-cities-2024-10-07"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "october-photo-2024-2024-10-21",
    "title": "Add one October 2024 photo of the real place, October 21, 2024",
    "seoTitle": "October 2024 business photo (law office, October 21, 2024)",
    "description": "October 2024 business photo for a law office on October 21, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-10-21",
    "cta": "This week, look at a photo from October 2024. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this October of the door, the work, or the counter. A photo from another season makes 2024 look unattended.",
          "This October 21, 2024 note is for a law office. The check is October 2024 business photo: a photo from October 2024, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from October 2024",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from October 2024. In October 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from October 2024 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from October 2024 before you add anything",
        "paragraphs": [
          "A mismatch on October 2024 business photo is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare a photo from October 2024. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the October 2024 hours on the door and the listing, October 14, 2024",
        "href": "/blog/october-hours-2024-2024-10-14"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "halloween-hours-2024-2024-10-28",
    "title": "Publish Halloween day hours, October 28, 2024",
    "seoTitle": "Halloween hours (retail shop, October 28, 2024)",
    "description": "Halloween hours for a retail shop on October 28, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-10-28",
    "cta": "This week, look at Halloween day hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Halloween 2024 often means an earlier close or a later door. Write the day itself, not a vague seasonal note.",
          "This October 28, 2024 note is for a retail shop. The check is Halloween hours: Halloween day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Halloween day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Halloween day hours. In October 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Halloween day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Halloween day hours before you add anything",
        "paragraphs": [
          "A mismatch on Halloween hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Halloween day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one October 2024 photo of the real place, October 21, 2024",
        "href": "/blog/october-photo-2024-2024-10-21"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "photos-not-in-the-summary-2024-11-04",
    "title": "Keep photos on the listing even if a summary skips them, November 4, 2024",
    "seoTitle": "Photos and an AI Overview (contractor, November 4, 2024)",
    "description": "Photos and an AI Overview for a contractor on November 4, 2024. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2024-11-04",
    "cta": "This week, look at photos on the listing. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The summary is text. The decision often happens on the photos. Add a current one.",
          "This November 4, 2024 note is for a contractor. The check is photos and an AI Overview: photos on the listing, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at photos on the listing",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at photos on the listing. In November 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Photos on the listing on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix photos on the listing before you add anything",
        "paragraphs": [
          "A mismatch on photos and an AI Overview is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare photos on the listing. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Fix profile hours if a summary has them wrong, September 30, 2024",
        "href": "/blog/overview-hours-from-profile-2024-09-30"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "veterans-hours-2024-2024-11-11",
    "title": "Set Veterans Day hours if you close, November 11, 2024",
    "seoTitle": "Veterans Day hours (salon, November 11, 2024)",
    "description": "Veterans Day hours for a salon on November 11, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-11-11",
    "cta": "This week, look at Veterans Day hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close or shorten Veterans Day 2024, write that day on the listing. The weekly schedule does not know the holiday.",
          "This November 11, 2024 note is for a salon. The check is Veterans Day hours: Veterans Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Veterans Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Veterans Day hours. In November 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Veterans Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Veterans Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Veterans Day hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Veterans Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish Halloween day hours, October 28, 2024",
        "href": "/blog/halloween-hours-2024-2024-10-28"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "no-holiday-in-the-name-2024-11-18",
    "title": "Keep the holiday out of the business name, November 18, 2024",
    "seoTitle": "Google business name (clinic, November 18, 2024)",
    "description": "Google business name for a clinic on November 18, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-11-18",
    "cta": "This week, look at the name on the listing. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A holiday phrase in the name can split the listing. Use a post for the greeting.",
          "This November 18, 2024 note is for a clinic. The check is Google business name: the name on the listing, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the name on the listing",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the name on the listing. In November 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The name on the listing on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the name on the listing before you add anything",
        "paragraphs": [
          "A mismatch on Google business name is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the name on the listing. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Veterans Day hours if you close, November 11, 2024",
        "href": "/blog/veterans-hours-2024-2024-11-11"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "thanksgiving-hours-2024-2024-11-25",
    "title": "Write Thanksgiving week hours before Monday, November 25, 2024",
    "seoTitle": "Thanksgiving hours (restaurant, November 25, 2024)",
    "description": "Thanksgiving hours for a restaurant on November 25, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-11-25",
    "cta": "This week, look at Thanksgiving week hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Put Thanksgiving 2024 hours on the profile before the week begins. A summary above the links can be stale. The hours field is what you control.",
          "This November 25, 2024 note is for a restaurant. The check is Thanksgiving hours: Thanksgiving week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Thanksgiving week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Thanksgiving week hours. In November 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Thanksgiving week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Thanksgiving week hours before you add anything",
        "paragraphs": [
          "A mismatch on Thanksgiving hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Thanksgiving week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the holiday out of the business name, November 18, 2024",
        "href": "/blog/no-holiday-in-the-name-2024-11-18"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "staff-party-closure-2024-12-02",
    "title": "Mark a staff party like any other closure, December 2, 2024",
    "seoTitle": "Staff party closure (law office, December 2, 2024)",
    "description": "Staff party closure for a law office on December 2, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-12-02",
    "cta": "This week, look at a staff closure. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the door is locked, the listing should say closed. A private note in the group text does not reach customers.",
          "This December 2, 2024 note is for a law office. The check is staff party closure: a staff closure, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a staff closure",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a staff closure. In December 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A staff closure on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a staff closure before you add anything",
        "paragraphs": [
          "A mismatch on staff party closure is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare a staff closure. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Thanksgiving week hours before Monday, November 25, 2024",
        "href": "/blog/thanksgiving-hours-2024-2024-11-25"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "draft-needs-cities-2024-12-09",
    "title": "A drafted service page still needs your cities, December 9, 2024",
    "seoTitle": "Cities in drafted copy (retail shop, December 9, 2024)",
    "description": "Cities in drafted copy for a retail shop on December 9, 2024. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2024-12-09",
    "cta": "This week, look at the cities on a drafted page. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Delete every town you will not drive to. A tool will add them to sound local.",
          "This December 9, 2024 note is for a retail shop. The check is cities in drafted copy: the cities on a drafted page, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the cities on a drafted page",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the cities on a drafted page. In December 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The cities on a drafted page on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the cities on a drafted page before you add anything",
        "paragraphs": [
          "A mismatch on cities in drafted copy is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the cities on a drafted page. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep photos on the listing even if a summary skips them, November 4, 2024",
        "href": "/blog/photos-not-in-the-summary-2024-11-04"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "december-popup-2024-12-16",
    "title": "Keep the December popup from covering the number, December 16, 2024",
    "seoTitle": "December popup (contractor, December 16, 2024)",
    "description": "December popup for a contractor on December 16, 2024. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2024-12-16",
    "cta": "This week, look at a popup over the number. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The busiest month is the worst month to hide the tap-to-call control.",
          "This December 16, 2024 note is for a contractor. The check is December popup: a popup over the number, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a popup over the number",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a popup over the number. In December 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A popup over the number on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a popup over the number before you add anything",
        "paragraphs": [
          "A mismatch on December popup is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare a popup over the number. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Tell the truth about July wait times, July 15, 2024",
        "href": "/blog/longer-july-waits-2024-07-15"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "christmas-hours-2024-2024-12-23",
    "title": "Separate Christmas Eve, Christmas Day, and the days after, December 23, 2024",
    "seoTitle": "Christmas hours (salon, December 23, 2024)",
    "description": "Christmas hours for a salon on December 23, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-12-23",
    "cta": "This week, look at Christmas week hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write each closed day of Christmas week 2024 on the profile. Do not trust a generated summary to know you are shut.",
          "This December 23, 2024 note is for a salon. The check is Christmas hours: Christmas week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Christmas week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Christmas week hours. In December 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Christmas week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Christmas week hours before you add anything",
        "paragraphs": [
          "A mismatch on Christmas hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Christmas week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark a staff party like any other closure, December 2, 2024",
        "href": "/blog/staff-party-closure-2024-12-02"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "new-year-hours-2025-2024-12-30",
    "title": "Set New Year hours before the week starts, December 30, 2024",
    "seoTitle": "New Year hours (clinic, December 30, 2024)",
    "description": "New Year hours for a clinic on December 30, 2024. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2024-12-30",
    "cta": "This week, look at New Year hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write New Year hours on the profile and the contact page for 2025. Check them on a phone, because that is where people look the night before.",
          "This December 30, 2024 note is for a clinic. The check is New Year hours: New Year hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at New Year hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at New Year hours. In December 2024 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "New Year hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix New Year hours before you add anything",
        "paragraphs": [
          "A mismatch on New Year hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare New Year hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2024 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Separate Christmas Eve, Christmas Day, and the days after, December 23, 2024",
        "href": "/blog/christmas-hours-2024-2024-12-23"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  }
];
